import { CircularProgress } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { useEffect, useState } from "react";
import { UserFormValues } from "src/models/User.model";
import {
  useEditUserMutation,
  useGetUserByIdQuery,
} from "src/services/UserServices";
import { showToast } from "src/utils/showToaster";
import { validPhoneRegex } from "src/utils/validations/numberInput";
import { array, object, string } from "yup";
import UserForm from "../Layouts/UserForm";
type Props = {
  onClose: () => void;
  userId: string;
};

const EditUserFormWrapper = ({ onClose, userId }: Props) => {

  const [editUser] = useEditUserMutation();
  const { data, isLoading, isFetching } = useGetUserByIdQuery(userId);
  const [userData, setUserData] = useState<any>();

  useEffect(() => {
    if (!isLoading && !isFetching) {
      setUserData(data?.data);
    }
  }, [data, isLoading, isFetching]);
  // Form Initial Values
  const initialValues: UserFormValues = {
    firstName: userData?.firstName || "",
    lastName: userData?.lastName || "",
    userName: userData?.userName || "",
    mobile: userData?.mobile || "",
    email: userData?.email || "",
    userRole: {
      label: userData?.userRole,
      value: userData?.userRole,
    },
    userType: userData?.userType || "ADMIN",
    branches:
      userData?.branches?.map((branch: any) => {
        return {
          label: branch?.branchName,
          value: branch?._id,
        };
      }) || [],
  };

  // Validation Schema
  const validationSchema = object().shape({
    firstName: string().required("Please enter first name"),
    lastName: string().required("Please enter last name"),
    userName: string().required("Please enter username"),
    email: string().email().required("Please enter email"),
    mobile: string()
      .matches(validPhoneRegex, "Please enter valid number")
      .required("Please enter mobile"),
    userRole: object().required("Please select role"),
    branches: array().min(1, "Please select branch"),
  });

  // Handle Submit
  const handleSubmit = (
    values: UserFormValues,
    { setSubmitting, resetForm }: FormikHelpers<UserFormValues>
  ) => {
    const formattedValues = {
      ...values,
      userRole: values?.userRole?.value,
      branches: values?.branches?.map((role: any) => {
        return role?.value;
      }),
    };
    editUser({
      body: formattedValues,
      userId: userId,
    }).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          resetForm();
          onClose();
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Dialog open maxWidth="xs" fullWidth>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {(formikProps) => (
          <Form>
            {(isLoading || isFetching) && (
              <div className="absolute w-[100%] h-[100%] flex justify-center items-center z-10 bg-slate-100 opacity-50">
                <CircularProgress />
              </div>
            )}
            <UserForm
              formikProps={formikProps}
              onClose={onClose}
              formType={"Edit"}
            />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default EditUserFormWrapper;
